import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useStickerSectionStore } from '../MugEditorFeature/EditorStore';
import localforage from 'localforage';
import { androidPhones, iOSPhones } from '../MugEditorFeature/utils/phoneDetails';
import { trybeTrack } from '../MugEditorFeature/utils/trybeTracking';

export default function CaseConfiguration() {
    const navigate = useNavigate();

    const setPhoneModel = useStickerSectionStore((state) => state.setPhoneModel);
    const phoneModel = useStickerSectionStore((state) => state.phoneModel)

    const [platform, setPlatform] = useState<'iOS' | 'Android'>('iOS');
    const [device, setDevice] = useState<string | null>(null);
    const fadeRef = useRef<HTMLDivElement | null>(null);
    const [displayedPhones, setDisplayPhones] = useState(iOSPhones)

    useEffect(() => {

        if (phoneModel) {

            setDevice(phoneModel)
            const isIOS = iOSPhones.some(phone => phone.value === phoneModel);
            const isAndroid = androidPhones.some(phone => phone.value === phoneModel);

            if (isIOS) {
                setDisplayPhones(iOSPhones)
                setPlatform('iOS')
            } else if (isAndroid) {
                setDisplayPhones(androidPhones)
                setPlatform('Android')
            }
        }

        if (fadeRef.current) {
            fadeRef.current.style.opacity = '1';
            fadeRef.current.style.pointerEvents = 'auto';
            fadeRef.current.style.transition = 'opacity 0.5s ease';
            setTimeout(() => fadeRef.current!.style.opacity = '0', 50);
            const timer = setTimeout(() => fadeRef.current!.style.pointerEvents = 'none', 550);
            return () => clearTimeout(timer);
        }
    }, []);



    const handleContinue = () => {
        if (!device) return;
        setPhoneModel(device);
        localforage.setItem("phoneModel", device);
        trybeTrack("phone_model_selected", { phoneModel: device, platform });
        setTimeout(() => navigate('/editor'), 0);
    };

    return (
        <div style={{ height: "100%", width: "100%", touchAction: "none" }}>
            <div ref={fadeRef} style={{
                position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
                backgroundColor: '#7a9a9a', opacity: 1, pointerEvents: 'auto', zIndex: 99999
            }} />

            <header style={{
                height: "10%", width: "100%", backgroundColor: "#3d5a5a",
                display: "flex", alignItems: "center", paddingLeft: "5%"
            }}>
                <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none", width: "100%" }}>
                    <h1 style={{ color: "#a8d8d8", fontFamily: "'Quicksand', sans-serif" }}>Mem</h1>
                    <h1 style={{ color: "#d4e8e8", fontFamily: "'Quicksand', sans-serif" }}>Case</h1>
                </Link>
            </header>

            <section style={{ height: "80%", width: "100%", backgroundColor: "#7a9a9a", display: "flex", flexDirection: "column" }}>
                <div style={{
                    width: "100%", display: "flex", justifyContent: "center", alignItems: "center",
                    gap: "2%", padding: "10px", borderBottom: "1px solid #5a7a7a"
                }}>
                    <button onClick={() => {
                        setPlatform('iOS')
                        setDisplayPhones(iOSPhones)
                    }
                    } style={{
                        padding: "8px 16px", borderRadius: "20px",
                        backgroundColor: platform === 'iOS' ? '#6b9e9e' : '#5a7a7a',
                        color: "#ffffff", border: "none", cursor: "pointer",

                    }}>iOS</button>
                    <button onClick={() => {
                        setPlatform('Android')
                        setDisplayPhones(androidPhones)
                    }
                    } style={{
                        padding: "8px 16px", borderRadius: "20px",
                        backgroundColor: platform === 'Android' ? '#6b9e9e' : '#5a7a7a',
                        color: "#ffffff", border: "none", cursor: "pointer"
                    }}>Android</button>
                </div>

                <div style={{
                    flexGrow: 1, overflowY: 'auto', padding: '20px',
                    display: 'flex', flexDirection: 'column', gap: '10px'
                }}>
                    {[...displayedPhones].reverse().map((model) => (
                        <button
                            key={model.value}
                            onClick={() => setDevice(model.value)}
                            style={{
                                padding: '12px',
                                borderRadius: '10px',
                                fontSize: '0.9rem',
                                backgroundColor: device === model.value ? '#6b9e9e' : '#5a8080',
                                color: '#f4f8f8',
                                border: device === model.value ? '1px solid #ffffff' : '1px solid #6b9e9e',
                                cursor: 'pointer',
                            }}
                        >
                            {model.name}
                        </button>
                    ))}
                </div>
            </section>

            <footer style={{
                height: "10%", width: "100%", backgroundColor: "#4a6a6a", display: "flex",
                justifyContent: "end", alignItems: "center", paddingRight: "5%", borderTop: "0.5px solid #3d5a5a"
            }}>
                <button onClick={handleContinue} disabled={!device} style={{
                    width: "120px", fontSize: ".75rem", fontFamily: "'Quicksand', sans-serif",
                    boxShadow: device ? "0 0 10px 2px #6b9e9e" : 'none',
                    height: "50px", backgroundColor: device ? "#6b9e9e" : '#5a7a7a',
                    color: "#ffffff", border: `2px solid ${device ? "#3d5a5a" : '#5a7a7a'}`,
                    borderRadius: "10px", opacity: device ? 1 : 0.6,
                    cursor: device ? 'pointer' : 'not-allowed'
                }}>
                    Continue
                </button>
            </footer>
        </div>
    );
}
